import { ContainerModule } from 'inversify';
import Tracker from '@framework/analytics-tracker/Tracker';
import DealroadshowTrackingManager from '@/dealroadshow/application/AnalyticsTracker/DealroadshowTrackingManager';
import Dispatcher from '@framework/analytics-tracker/Sender/senders/SocketDispatcher';
import DITypes from '@drs/socket-client/DITypes';

export const analyticsModule: ContainerModule = new ContainerModule(({ bind }) => {
  bind(Dispatcher).toDynamicValue(({ get }) => get(DITypes.SocketDispatcher)).inSingletonScope();
  bind(DealroadshowTrackingManager).toSelf().inSingletonScope();
  bind(Tracker)
    .toDynamicValue(({ get }) => get(DealroadshowTrackingManager))
    .inSingletonScope();
});
